import { Injectable, TemplateRef } from '@angular/core';
import { MatDialogConfig, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MediaObserver } from '@angular/flex-layout';
import { defaults, clone } from 'lodash';
import { AlertDialogData } from '../interfaces/alert-dialog-data.interface';
import { AlertWrapperComponent } from '../dialogs/alert-wrapper/alert-wrapper.component';
import { ComponentType } from '@angular/cdk/overlay';
import { MaterialMediaQueries } from '../enums/material-media-queries.enum';

@Injectable()
export class XpoDialogManagerService {
  private configDefaults: MatDialogConfig;

  constructor(private matDialog: MatDialog, private mediaQueryService: MediaObserver) {
    this.configDefaults = {
      width: '650px',
    };

    this.initializeWatchers();
  }

  public alert(alertOptions: AlertDialogData, configOverrides: MatDialogConfig = {}): MatDialogRef<any> {
    const defaultsWithData = defaults(configOverrides, clone(this.configDefaults));
    defaultsWithData.data = alertOptions;

    return this.matDialog.open(AlertWrapperComponent, defaultsWithData);
  }

  public open(dialogComponent: ComponentType<any> | TemplateRef<any>, configOverrides: MatDialogConfig = {}): MatDialogRef<any> {
    const dialogConfig = defaults(configOverrides, clone(this.configDefaults));

    return this.matDialog.open(dialogComponent, dialogConfig);
  }

  private initializeWatchers(): void {
    this.mediaQueryService.asObservable().subscribe(mediaChange => {
      this.configDefaults.width = this.mediaQueryService.isActive(MaterialMediaQueries.GT_MEDIUM) ? '650px' : '80%';
    });
  }
}
